export default __webpack_public_path__ + "static/media/dog.3269a4f4.jpg";